/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Reducer file for authentication
 */

import {
  PO_STATS,
  CMO_STATS,
  SHIPMENT_STATS,
  PO_DATA,
  EXEC_CARDS,
  EXEC_LINES_OVERVIEW,
  EXEC_LINES_CMO,
  EXEC_LINE_ITEMS,
  EXEC_BATCH_ITEMS,
} from "../../actions/types";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case PO_STATS:
      return {
        ...state,
        poStats: action.payload,
      };
    case CMO_STATS:
      return {
        ...state,
        cmoStats: action.payload,
      };
    case SHIPMENT_STATS:
      return {
        ...state,
        shipmentStats: action.payload,
      };
    case PO_DATA:
      return {
        ...state,
        poList: action.payload,
      };
    case EXEC_CARDS:
      return {
        ...state,
        overviewCards: action.payload,
      };
    case EXEC_LINES_OVERVIEW:
      return {
        ...state,
        lineItemsOverview: action.payload,
      };
    case EXEC_LINES_CMO:
      return {
        ...state,
        lineItemsCMO: action.payload,
      };
    case EXEC_LINE_ITEMS:
      return {
        ...state,
        execLineItems: action.payload,
      };
    case EXEC_BATCH_ITEMS:
      return {
        ...state,
        execBatchItems: action.payload,
      };
    default:
      return state;
  }
}
